import React from 'react'
import ReactDOM from 'react-dom'
import App from './App.jsx'

import {/*registerServiceWorker,*/ unregister } from './registerServiceWorker'

ReactDOM.render(<App />, document.getElementById('root'))
//registerServiceWorker()
unregister()



// WEBPACK FOOTER //
// ./src/index.js